import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';

import Spinner from '../../components/Widgets/spinner';
import ConfirmActionModal from '../Common/confirmActionModal';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import CashFormatter from '../Common/cashFormatter';
import { DateFormatter } from '../Common/dateFormat';
import checkPermission from '../Common/permissions';
import { ROOT_URL, companyCodeTitle, isElegant, isFung } from '../../actions/root_url';
import dateFilterRadios from '../Common/dateFilterRadios';
import { toFromDates, convertUtcDate } from '../Common/cleanDates';
import SpinnerButton from '../Common/SpinnerButton';

class InventoryReturn extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,
        invoice: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        details: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        selectedRows: null,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,

        days: '7',
        fromDate: undefined,
        toDate: undefined,
      };

      this.handleResize = this.handleResize.bind(this);
      this.checkAuthorize = this.checkAuthorize.bind(this);
      this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
      this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
      this.setToDate = this.setToDate.bind(this);
      this.setFromDate = this.setFromDate.bind(this);
      this.handleDaysFilterChange = this.handleDaysFilterChange.bind(this);
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      window.addEventListener('resize', this.handleResize);
      const { fromDate, toDate, days } = this.state;
      // this.props.setDefaultDays("inventoryReturn");
      this.props.fetchInventoryReturns(fromDate, toDate, days);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
        this.closeCheckAuthorize();
        if (this.state.action === 'void') {
          this.voidReturn();
        }
      }
      if (nextProps.inventoryReturn && nextProps.inventoryReturn !== this.props.inventoryReturn) {
        const invoice = { ...this.state.invoice, rows: nextProps.inventoryReturn };
        this.setState({ invoice });
      }
      if (nextProps.inventoryReturnDetails && nextProps.inventoryReturnDetails !== this.props.inventoryReturnDetails) {
        const details = { ...this.state.details, rows: nextProps.inventoryReturnDetails.Sales_Return_Line };
        this.setState({ details });
      }
      if (nextProps.updated) {
        this.context.router.push('/inventoryReturn/');
      }
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    setToDate(e) {
      if (e < this.state.fromDate) {
        return;
      }
      this.setState({ toDate: e });
    }

    setFromDate(e) {
      if (e > this.state.toDate) {
        return;
      }
      this.setState({ fromDate: e });
    }

    setToRangeSearch = () => {
      this.setState({ days: '-1' });
    }

    handleDaysFilterChange(Days) {
      const { fromDate, toDate } = this.state;
      this.setState(
        { days: Days },
        () => { this.props.fetchInventoryReturns(fromDate, toDate, Days); },
      );
    }

    checkAuthorize(password) {
      this.props.checkPassword(password);
    }

    openCheckAuthorize(action) {
      this.props.clearCheckPassword();
      this.setState({ checkAuthorizeOpen: true, action });
    }

    closeCheckAuthorize() {
      this.setState({ checkAuthorizeOpen: false });
    }

    voidReturn() {
      this.props.voidReturn(this.state.invoice.selectedRows[0].SalesReturn_id);
    }

    handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    shouldDisableVoidButton() {
      const { selectedRows } = this.state.invoice;
      if ((selectedRows.length > 0 &&
        selectedRows[0].ReturnStatus === 'Released' &&
        (selectedRows[0].CreditStatus === 'Credit' || selectedRows[0].CreditStatus === 'N/A')) ||
        !checkPermission('delete_sales_return')) {
        return false;
      }
      return true;
    }

    shouldDisableEditButton() {
      const { selectedRows } = this.state.invoice;
      if ((selectedRows.length > 0 &&
        selectedRows[0].ReturnStatus === 'Released' &&
        (selectedRows[0].CreditStatus === 'Credit' || selectedRows[0].CreditStatus === 'N/A')) ||
        !checkPermission('change_sales_return')) {
        return false;
      }
      return true;
    }

    // Once priceLevels are ready, reset state.
    updateRows(e) {
      e.preventDefault();
      this.props.editInventoryReturns(this.state.editedRows);
    }

    // formatDate(date) {
    //   if (!date) {
    //     return;
    //   }
    //   let formattedDate = `${date.getFullYear()}-`;
    //   formattedDate += `${date.getMonth() + 1}-`;
    //   if (date.getDate() < 10) {
    //     formattedDate += `0${date.getDate()}`;
    //   } else {
    //     formattedDate += date.getDate();
    //   }
    //   return formattedDate;
    // }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
      if (this.props.inventoryReturnIsLoading && !this.props.inventoryReturnError) {
        return <Spinner />;
      } // else if (this.props.inventoryReturnError) {
      //   return (
      //     <ContentWrapper>
      //       <div className="alert alert-danger">
      //         {JSON.stringify(this.props.inventoryReturnError)}
      //       </div>
      //     </ContentWrapper>
      //   );
      // }
      // else {
      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.invoice);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const invoice = Object.assign({}, this.state.invoice, { sortColumn, sortDirection });
        this.setState({
          invoice, 
        });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.invoice.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const invoice = { ...this.state.invoice, filters: newFilters };
        this.setState({ invoice });
      };

      const onRowsSelected = (rows) => {
        const allRows = this.state.invoice.rows;
        const newRows = getRows();
        allRows.map((r) => {
          if (r === rows) {
            r.isSelected = true;
          }
          r.isSelected = false;
        });
        let curRow = {};
        rows.map((r) => {
          curRow = newRows[r.rowIdx];
          newRows[r.rowIdx].isSelected = true;
        });
        let selectedRows = [];
        selectedRows = selectedRows.concat(rows.map(r => r.row));
        const invoice = { ...this.state.invoice, rows: allRows, selectedRows };
        this.setState({ invoice });
        this.props.fetchInventoryReturnsDetails(curRow.SalesReturn_id);
      };

      const onRowsDeselected = (rows) => {
        const newRows = this.state.invoice.rows;
        let curRow = false;
        rows.map((r) => {
          curRow = newRows[r.rowIdx];
          newRows[r.rowIdx].isSelected = false;
        });
        this.setState({ isSelected: false, curRow });
        const selectedRows = [];
        const invoice = { ...this.state.invoice, rows: newRows, selectedRows };
        this.setState({ invoice });
      };

      const columns = [
        {
          key: 'SRNum',
          name: <Translate value="rtn_no" />,
          resizable: true,
          width: 150,
          sortable: true,
          filterable: true,
        },
        {
          key: 'Deliver_Customer_Num',
          name: <Translate value="cust_no" />,
          resizable: true,
          width: 130,
          sortable: true,
          filterable: true,
        },
        {
          key: 'Deliver_Customer_Name',
          name: <Translate value="cust_name" />,
          resizable: true,
          width: 180,
          sortable: true,
          filterable: true,
        },
        {
          key: 'PostingDate',
          name: <Translate value="return_date" />,
          resizable: true,
          width: 126,
          sortable: true,
          filterable: true,
          formatter: DateFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'ReturnStatus',
          name: <Translate value="return_status" />,
          resizable: true,
          width: 140,
          sortable: true,
          filterable: true,
        },
        {
          key: 'RestockStatus',
          name: <Translate value="restock_status" />,
          resizable: true,
          width: 150,
          sortable: true,
          filterable: true,
        },
        {
          key: 'CreditStatus',
          name: <Translate value="credit_status" />,
          resizable: true,
          width: 135,
          sortable: true,
          filterable: true,
        },
        ...isFung ? [{
          key: 'QBSyncToken',
          name: <Translate value="QBSyncStatus" />,
          resizable: true,
          width: 135,
          getRowMetaData: row => row,
          formatter: ({value}) => {
            return <div>{value == '0' ? 'yes' : 'no'}</div>
          }
        },] : [],
        {
          key: 'FinalPrice',
          name: <Translate value="final" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'UnusedCredit',
          name: <Translate value="balance" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'Note',
          name: <Translate value="notation" />,
          resizable: true,
          width: 200,
          sortable: true,
          filterable: true,
        },
      ];

      return (
        <Row>
          <Col sm={12}>
            <div style={{ maxWidth: '100%', height: '300px' }} id="InventoryReturn-dataGrid1">
              <ReactDataGrid
                rowKey="SalesReturnLine_id"
                enableCellSelect
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={250}
                rowHeight={25}
                enableRowSelect="single"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      );
      // }
    }

    renderDetails() {
      if (this.props.inventoryReturnDetailsIsLoading && !this.props.inventoryReturnDetailsError) {
        return <Spinner />;
      } // else if (this.props.inventoryReturnDetailsError) {
      //   return (
      //     <ContentWrapper>
      //       <div className="alert alert-danger">
      //         {JSON.stringify(this.props.inventoryReturnDetailsError)}
      //       </div>
      //     </ContentWrapper>
      //   );
      // }
      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.details);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const details = Object.assign({}, this.state.details, { sortColumn, sortDirection });
        this.setState({
          details,
        });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.details.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const details = { ...this.state.details, filters: newFilters };
        this.setState({ details });
      };

      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
            return (
              <span>
                {this.props.value}
                <label className="label label-success">
                  <Translate value="non_fixed" />
                </label>
              </span>
            );
          }
          return (
            <span>
              {this.props.value}
            </span>
          );
        },
      });

      // Column difinition

      const DateFormatter = React.createClass({
        render() {
          return (
            <span>
              {moment.utc(this.props.dependentValues.CreateTime).local().format('YYYY-MM-DD')}
            </span>
          );
        },
      });

      const columns = [
        {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          width: 280,
          sortable: true,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          width: 130,
          sortable: true,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_no" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_price" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'ReturnQuantity',
          name: <Translate value="return_qty" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: IsFixedFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'ReturnWeight',
          name: <Translate value="rtn_wt" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
        },
        {
          key: 'ReturnTotalPrice',
          name: <Translate value="total" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'ReturnReason',
          name: <Translate value="return_reason" />,
          resizable: true,
          width: 140,
          sortable: true,
          filterable: true,
        },
        {
          key: 'RestockQuantity',
          name: <Translate value="restock_qty" />,
          resizable: true,
          width: 120,
          sortable: true,
          filterable: true,
        },
        {
          key: 'RestockWeight',
          name: <Translate value="restock_wt" />,
          resizable: true,
          width: 120,
          sortable: true,
          filterable: true,
        },
      ];

      return (
        <Row>
          <Col sm={12}>
            <div style={{ maxWidth: '100%', height: '300px' }} id="InventoryReturn-dataGrid2">
              <ReactDataGrid
                rowKey="SalesReturnLine_id"
                enableCellSelect
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={250}
                rowHeight={25}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderPrintButton() {
      const { invoice: { selectedRows } } = this.state;
      const disabled = selectedRows && selectedRows.length !== 1;
      const { SalesReturn_id: salesReturnID } = selectedRows && selectedRows.length === 1 && selectedRows[0];
      const token = `Bearer=${localStorage.getItem('token')}`;
      const url = `${ROOT_URL}v1/sale/printreturn/${salesReturnID}?${token}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          disabled={disabled}
        >
          <em className="fa fa-print" /><Translate value="print" />
        </Button>
      );
    }

    renderNoPriceButton() {
      const { invoice: { selectedRows } } = this.state;
      const disabled = selectedRows && selectedRows.length !== 1;
      const { SalesReturn_id: salesReturnID } = selectedRows && selectedRows.length === 1 && selectedRows[0];
      const token = `Bearer=${localStorage.getItem('token')}`;
      const url = `${ROOT_URL}v1/sale/printreturn_no_price/${salesReturnID}?${token}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          disabled={disabled}
        >
          <em className="fa fa-print" /><Translate value="no_price" />
        </Button>
      );
    }

    renderSyncToQB = () => {
      const {
        selectedRows,
      } = this.state.invoice
      const sales_return_ids = _.map(selectedRows, row => row.SalesReturn_id).join(',');
      const havNo = selectedRows.filter(row => row.QBSyncToken == '0')
      const enabled = () => {
        if (checkPermission("set_released_sales_invoice") && selectedRows.length && !havNo.length) {
          return true;
        }
        return false;
      }
      return(
        <SpinnerButton
          bsStyle="primary"
          disabled={!enabled()}
          translation={<Translate value="sync_to_QB" />}
          loading={this.props.syncQbLoading}
          onClick={() => {
            this.props.syncSalesReturnsToQB(sales_return_ids);
          }}
        />
      )
    }

    renderExportButton = () => {
      const { fromDate, toDate } = this.state;

      const dates = toFromDates(this.state.days, fromDate, toDate);
      const token = `Bearer=${localStorage.getItem('token')}`;
      const url = `${ROOT_URL}v1/sale/sales_return/?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&format=csv&${token}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          disabled={false}
        >
          <em className="fa fa-print" /><Translate value="export" />
        </Button>
      );
    }

    renderExportLineButton = () => {
      const { fromDate, toDate } = this.state;

      const dates = toFromDates(this.state.days, fromDate, toDate);
      const token = `Bearer=${localStorage.getItem('token')}`;
      const url = `${ROOT_URL}v1/sale/sales_return/export_line/?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&format=csv&${token}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          disabled={false}
        >
          <em className="fa fa-print" /><Translate value="export_line" />
        </Button>
      );
    }

    render() {
      const createDialogStyle = {
        width: '550px',
        height: '300px',
        marginLeft: '-15%',
      };
      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="returns" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="sales_return" />
            </Breadcrumb.Item>
          </Breadcrumb>
          {/* <div className="content-heading"><Translate value="inventory" /></div> */}
          <Grid id="inventory-return">
            {/* <h1><Translate value="sales_return" /></h1> */}
            <Row>
              <Col sm={12}>
                <Panel id="date-range-picker" className="form-horizontal">
                  <Row>
                    <Col xs={1}>
                      <h3 className="filter-title text-nowrap"><Translate value="return_date" /><span className="colon">:</span></h3>
                    </Col>
                    <Col xs={11}>
                      {
                        dateFilterRadios({
                          handleOnClick: this.handleDaysFilterChange,
                          setFromDate: this.setFromDate,
                          setToDate: this.setToDate,
                          setToRangeSearch: this.setToRangeSearch,
                          FromDate: this.state.fromDate,
                          ToDate: this.state.toDate,
                          Days: this.state.days,
                        })
                      }
                    </Col>
                  </Row>
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Panel className="position-relative table-collapse-fix" style={{ height: '350px' }}>
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="warning"
                      type="submit"
                      onClick={() => {
                        this.context.router.push(`/customerReturn/${this.state.invoice.selectedRows[0].SalesReturn_id}`);
                      }}
                      disabled={false}
                    >
                      <em className="fa fa-edit" /><Translate value="edit" />
                    </Button>
                    <Button
                      bsStyle="primary"
                      type="submit"
                      onClick={() => {
                        // this.props.completeReturn(this.state.invoice.selectedRows[0].SalesReturn_id)
                        this.context.router.push(`/restockReturn/${this.state.invoice.selectedRows[0].SalesReturn_id}`);
                      }}
                      disabled={this.state.invoice.selectedRows.length === 0 || this.state.invoice.selectedRows[0].RestockStatus !== 'Restock' || !checkPermission('change_sales_return')}
                    >
                      <em className="fa fa-plus" /><Translate value="restock" />
                    </Button>
                    <Button
                      bsStyle="danger"
                      type="submit"
                      onClick={() => { this.openCheckAuthorize('void'); }}
                      disabled={this.shouldDisableVoidButton()}
                    >
                      <em className="fa fa-trash" /><Translate value="void" />
                    </Button>
                    { this.renderPrintButton() }
                    { this.renderNoPriceButton() }
                    { this.renderExportButton() }
                    { isFung && this.renderSyncToQB()}
                    { isElegant && this.renderExportLineButton() }
                  </ButtonToolbar>
                  {this.renderTable() }
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Panel className="position-relative table-collapse-fix" style={{ height: '360px' }}>
                  {this.renderDetails() }
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col sm={2}>
                { this.props.inventoryReturnIsEditing && <div><Spinner /><Translate value="uploading" /></div> }
                { this.props.inventoryReturnEdited && <div className="alert alert-success"><Translate value="saved" /></div>}
                { this.props.editInventoryReturnError && <div className="alert alert-danger marginTopStyle" >{this.props.editInventoryReturnError}</div> }
              </Col>
            </Row>
          </Grid>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.checkAuthorizeOpen}
            onCloseClicked={this.closeCheckAuthorize}
          >
            <ConfirmActionModal
              case="confirmPassword"
              closeC={this.checkAuthorize}
              checkPasswordFailure={this.props.checkPasswordFailure}
            />
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
}

export default InventoryReturn;



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/inventoryReturn.jsx